




























































import { TableHeader, Params } from '@/utils/interfaces'
import ActionButton from '@/components/ActionButton.vue'
import { getUsers } from '@/api/Users/users.api'
import { User } from '@/api/Auth/auth.interface'
import { tableHandler } from '@/utils/mixins/tableHandler'
import UsersFilter from '@/components/Agency/Users/UsersFilter.vue'
import { getProfile } from '@/api/Auth/auth.api'
import Dialog from '@/components/Dialog.vue'
import TransferBalance from '@/components/TransferBalance.vue'
import BalanceLabel from '@/components/BalanceLabel.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<User>().extend({
  components: {
    appActionButton: ActionButton,
    appUsersFilter: UsersFilter,
    appDialog: Dialog,
    appTransferBalance: TransferBalance,
    BalanceLabel,
    FlatCard,
    FlatTable,
  },
  data() {
    return {
      extraQuerys: this.$route.query as undefined | object,
      headers: [
        {
          text: this.$t('user.user'),
          value: 'username',
        },
        {
          text: this.$t('balance'),
          value: 'balance',
        },
        {
          text: this.$t('transfer'),
          value: 'actions',
        },
      ] as TableHeader[],
    }
  },
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    async getUsers(params?: Params) {
      const response = await getUsers({
        ...this.extraQuerys,
        ...params,
        not_self: true,
      })
      this.extraQuerys = undefined
      return response
    },
  },
  async mounted() {
    const response = await getProfile()
    this.$store.commit('UPDATE_PROFILE', response.data)
  },
})
